import { createContext, use, useState, ReactNode } from "react";

interface SearchEverywhereContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const SearchEverywhereContext = createContext<SearchEverywhereContextValue | null>(null);

export function SearchEverywhereProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return <SearchEverywhereContext value={{ open, setOpen }}>{children}</SearchEverywhereContext>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSearchEverywhere() {
  const ctx = use(SearchEverywhereContext);
  if (!ctx) throw new Error("useSearchEverywhere must be used within a SearchEverywhereProvider");
  return ctx;
}
